import { render, staticRenderFns } from "./PortfoliosList.vue?vue&type=template&id=ff1a5e40&scoped=true"
import script from "./PortfoliosList.vue?vue&type=script&lang=ts&setup=true"
export * from "./PortfoliosList.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./PortfoliosList.vue?vue&type=style&index=0&id=ff1a5e40&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1a5e40",
  null
  
)

export default component.exports